import {command, queryAll, queryOne, querySearch} from "../utils/api";

const GET_TILLS_URL = `${process.env.PUBLIC_URL}/api/v1/r/tills`;

export const GET_TILLS = 'GET_TILLS';
export const GET_TILLS_COMPLETED = 'GET_TILLS_COMPLETED';
export const GET_TILLS_FAILED = 'GET_TILLS_FAILED';
export function getTills({dispensaryId}) {
  const filter = {
    where: {dispensaryId}
  };
  return queryAll(GET_TILLS_URL, filter, GET_TILLS, GET_TILLS_COMPLETED, GET_TILLS_FAILED);
}

export const SEARCH_TILLS = 'SEARCH_TILLS';
export const SEARCH_TILLS_COMPLETED = 'SEARCH_TILLS_COMPLETED';
export const SEARCH_TILLS_FAILED = 'SEARCH_TILLS_FAILED';
export const searchTills = querySearch(GET_TILLS_URL, SEARCH_TILLS, SEARCH_TILLS_COMPLETED, SEARCH_TILLS_FAILED,
  ['name', 'description']);

export const GET_TILL = 'GET_TILL';
export const GET_TILL_COMPLETED = 'GET_TILL_COMPLETED';
export const GET_TILL_FAILED = 'GET_TILL_FAILED';
export function getTill({tillId}) {
  const filter = {
    where: {tillId}
  };
  return queryOne(GET_TILLS_URL, filter, GET_TILL, GET_TILL_COMPLETED, GET_TILL_FAILED);
}

const TILLS_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/till`;

export const ADD_TILL = 'ADD_TILL';
export const ADD_TILL_COMPLETED = 'ADD_TILL_COMPLETED';
export const ADD_TILL_FAILED = 'ADD_TILL_FAILED';
export const addTill = command(TILLS_ACTION_URL + '/addTill', ADD_TILL, ADD_TILL_COMPLETED, ADD_TILL_FAILED);

export const UPDATE_TILL = 'UPDATE_TILL';
export const UPDATE_TILL_COMPLETED = 'UPDATE_TILL_COMPLETED';
export const UPDATE_TILL_FAILED = 'UPDATE_TILL_FAILED';
export const updateTill = command(TILLS_ACTION_URL + '/updateTill', UPDATE_TILL, UPDATE_TILL_COMPLETED,
  UPDATE_TILL_FAILED);



// WEBPACK FOOTER //
// ./src/Till/actions.js